import styled from 'styled-components';

const FormStyle = styled.form`
  &&& {
    .wrapper {
      background: white;
      padding: 24px 30px;
      border-radius: 20px;
      border: 1px solid #eae8e8;
      .ant-upload-text {
        color: #4b97e9;
        border-bottom: 1px dotted;
      }
      .ant-upload {
        padding: 0px !important;
      }
      .ant-upload-picture-card-wrapper {
        position: relative;
      }
      .ant-upload-select-picture-card {
        border: none;
        background: none;
        width: 42px;
        height: 42px;
        margin: 0;
        padding: 0;
      }

      .uploadButton {
        position: absolute;
        left: 51px;
        top: 12px;
      }
    }

    .ant-input-group {
      display: flex;
      flex-direction: column;
    }
    .ant-input-group-addon {
      background: none;
      border: none;
      font-size: 12px;
      color: #9f9f9f;
      padding: 0;
      margin-bottom: 8px;
    }
    .ant-input,
    .ant-input-password {
      border-radius: 6px;
    }
    .anticon {
      font-size: 20px;
    }
    .change_pass {
      span {
        color: #929292;
        border-bottom: 1px dotted #929292;
        &:hover {
          color: #4b97e9;
          border-bottom: 1px dotted #4b97e9;
        }
      }
    }
    .create {
      span {
        border-bottom: 1px dotted #929292;
      }
    }
    .delete {
      span {
        color: #ff3d3d;
        border-bottom: 1px dotted #ff3d3d;
      }
    }
    .change_pass {
      padding: 0;
      margin: 0;
      height: auto;
      padding-right: 11px;
    }
    .ant-col {
      position: relative;
    }
    .validate {
      color: #ff3d3d;
    }
    .anticon.anticon-close {
      position: absolute;
      top: 0;
      right: -19px;
      font-size: 18px;
    }
  }
`;

export default FormStyle;
